import { render } from "./DashboardOrdersFinished.vue?vue&type=template&id=277bdb0a"
import script from "./DashboardOrdersFinished.vue?vue&type=script&lang=js"
export * from "./DashboardOrdersFinished.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__